var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHorizontalDividerCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 2"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 1,
  x2: 9,
  y2: 1,
  stroke: "#4F31FF",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgHorizontalDividerCheck;